module.exports = __webpack_public_path__ + "static/img/about1.bcefed3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/about1.jpg
// module id = iyYi
// module chunks = 0